export default __webpack_public_path__ + "static/media/pithoragarh.8403b6ae.jpg";